import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "add",
  "use": "add-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol viewBox=\"0 0 90 90\" id=\"add\"><title>资源 106</title><g id=\"add_图层_2\" data-name=\"图层 2\"><g id=\"add_图层_1-2\" data-name=\"图层 1\"><rect x=\"21.82\" y=\"42.1\" width=\"46.36\" height=\"5.8\" rx=\"2.12\" ry=\"2.12\" /><rect x=\"21.82\" y=\"42.1\" width=\"46.36\" height=\"5.8\" rx=\"2.12\" ry=\"2.12\" transform=\"translate(0 90) rotate(-90)\" /><path d=\"M45,5A40,40,0,1,1,5,45,40,40,0,0,1,45,5m0-5A45,45,0,1,0,90,45,45,45,0,0,0,45,0Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/add.svg
// module id = 4cSG
// module chunks = 264